var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { PlaybackManager, PlayerProgress, PlayerState } from "../player";
import { UserContextConsumer } from '../context/user';
var WaveForm = /** @class */ (function (_super) {
    __extends(WaveForm, _super);
    function WaveForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            progressContainerWidth: 0
        };
        _this.onResize = _this.onResize.bind(_this);
        return _this;
    }
    WaveForm.prototype.componentDidMount = function () {
        var _this = this;
        var sound = this.props.sound;
        this.stateSubscription = PlaybackManager.getInstance().addPlaybackStateListener(function (state) {
            if (state.media && state.media.sound && sound.id == state.media.sound.id) {
                _this.subscribeIfNeeded();
            }
            else if (_this.subscription) {
                _this.setState({ progressState: undefined });
                PlaybackManager.getInstance().removePlaybackStateListener(_this.subscription);
                _this.subscription = undefined;
            }
            else if (_this.state.progressState) {
                _this.setState({ progressState: undefined });
            }
        });
        document.addEventListener('resize', this.onResize);
    };
    WaveForm.prototype.componentWillUnmount = function () {
        if (this.stateSubscription) {
            PlaybackManager.getInstance().removePlaybackStateListener(this.stateSubscription);
            this.stateSubscription = undefined;
        }
        if (this.subscription) {
            PlaybackManager.getInstance().removePlaybackStateListener(this.subscription);
            this.subscription = undefined;
        }
        document.removeEventListener('resize', this.onResize);
    };
    WaveForm.prototype.subscribeIfNeeded = function () {
        var _this = this;
        if (this.subscription == undefined) {
            this.subscription = PlaybackManager.getInstance().addPlaybackProgressStateListener(function (state) {
                _this.setState({ progressState: state });
            });
        }
    };
    WaveForm.prototype.onResize = function (e) {
        if (this.containerRef)
            this.setState({ progressContainerWidth: this.containerRef.clientWidth });
    };
    WaveForm.prototype.setContainerRef = function (ref) {
        this.containerRef = ref;
        if (this.containerRef && this.state.progressContainerWidth != (this.containerRef.clientWidth))
            this.setState({ progressContainerWidth: this.containerRef.clientWidth });
    };
    WaveForm.prototype.render = function () {
        var _this = this;
        var sound = this.props.sound;
        var coloredStyle = {
            width: (this.state.progressContainerWidth || 0) + 'px',
            backgroundImage: (sound.wave.red ? "url('" + sound.wave.red + "')" : '')
        };
        return React.createElement(UserContextConsumer, null, function (user) {
            var _a;
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "wave-form optimize-contrast", ref: function (ref) { return _this.setContainerRef(ref); }, onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var percent, targetDuration, track_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    e.stopPropagation();
                                    percent = (100 / e.currentTarget.clientWidth) * e.nativeEvent.offsetX;
                                    if (!(PlaybackManager.getInstance().getTrack() && sound.id == PlaybackManager.getInstance().getTrack().sound.id && PlaybackManager.getInstance().getDuration())) return [3 /*break*/, 1];
                                    targetDuration = PlaybackManager.getInstance().getDuration() * (percent / 100);
                                    PlaybackManager.getInstance().seek(targetDuration);
                                    return [3 /*break*/, 3];
                                case 1:
                                    if (!this.props.playlist) return [3 /*break*/, 3];
                                    track_1 = this.props.playlist.tracks().find(function (a) { return a.sound.id == sound.id; });
                                    if (!track_1) return [3 /*break*/, 3];
                                    return [4 /*yield*/, PlaybackManager.getInstance().startTrack(track_1, true, function (sounds, duration) {
                                            if (sound.id == track_1.sound.id) {
                                                var targetDuration = duration * (percent / 100);
                                                PlaybackManager.getInstance().seek(targetDuration);
                                            }
                                        })];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, style: { backgroundImage: (sound.wave[user.theme == 'white' ? 'light' : 'gray'] ? "url('" + sound.wave[user.theme == 'white' ? 'light' : 'gray'] + "')" : ''), position: 'relative' } },
                    _this.state.progressState && Boolean(_this.state.progressState.progress) && React.createElement("div", { className: "colored-wave", style: {
                            width: PlayerProgress.progressInPercent(PlaybackManager.getInstance().getProgress(), PlaybackManager.getInstance().getDuration()) + "%"
                        } },
                        React.createElement("div", { className: "colored-wave-inner", style: coloredStyle })),
                    (!_this.state.progressState || _this.state.progressState.progress == 0)
                        && (((_a = _this.state.progressState) === null || _a === void 0 ? void 0 : _a.state) !== PlayerState.Playing)
                        && sound.streamed
                        && sound.duration && React.createElement("div", { className: "colored-wave", style: {
                            width: PlayerProgress.progressInPercent(parseFloat(sound.streamed), parseFloat(sound.duration)) + "%"
                        } },
                        React.createElement("div", { className: "colored-wave-inner-gray", style: {
                                width: (_this.state.progressContainerWidth || 0) + 'px',
                                backgroundImage: (sound.wave.red ? "url('" + sound.wave.red + "')" : '')
                            } }))));
        });
    };
    return WaveForm;
}(React.Component));
export { WaveForm };
//# sourceMappingURL=WaveForm.js.map